import { render } from "./App.vue?vue&type=template&id=71ba93cc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=71ba93cc&lang=less"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__